<h2 mat-dialog-title>New Scenario</h2>

<mat-dialog-content>
	<form [formGroup]="form" class="d-flex flex-column gap-3 pt-1">
		<mat-form-field appearance="outline" class="w-100">
			<mat-label>Scenario name</mat-label>
			<input matInput [formControl]="form.controls.name" placeholder="e.g. Scenario 2 — Rate Increase" />
			@if (form.controls.name.touched && form.controls.name.invalid) {
				<mat-error>Scenario name is required</mat-error>
			}
		</mat-form-field>

		<mat-form-field appearance="outline" class="w-100">
			<mat-label>Copy from (optional)</mat-label>
			<mat-select [formControl]="form.controls.copyFromId">
				<mat-option value="">Start blank</mat-option>
				@for (scenario of data.scenarios; track scenario.id) {
					<mat-option [value]="scenario.id">{{ scenario.name }}</mat-option>
				}
			</mat-select>
		</mat-form-field>
	</form>
</mat-dialog-content>

<mat-dialog-actions align="end">
	<button mat-button type="button" (click)="cancel()">Cancel</button>
	<button mat-flat-button color="primary" type="button" [disabled]="form.invalid" (click)="create()">Create</button>
</mat-dialog-actions>
